import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { mq } from '@olxeu-a2b/ui/src/commons/styles';
import styled from '@nexus/lib-react/dist/theme/styled';
import useGetDac7Data from '@olxeu-a2b/delivery-utils/src/bindings/orders-overview/hooks/dac7/useGetDac7Data';
import { useViewport } from '@olxeu-a2b/delivery-utils/src/hooks';
import { USER_ID_COOKIE, getCookie } from '@olxeu-a2b/core/src/utils/cookie';
import DAC7ProfileBlockedAt from '@olxeu-a2b/ui/src/pages/orders/components/dac7/DAC7ProfileBlockedAt';
import DAC7ProfileSubmittedAt from '@olxeu-a2b/ui/src/pages/orders/components/dac7/DAC7ProfileSubmittedAt';
import DAC7ProfileFillDetails from '@olxeu-a2b/ui/src/pages/orders/components/dac7/DAC7ProfileFillDetails';
import ThemeProvider from '@nexus/lib-react/dist/theme/CoreTheme/CoreThemeProvider';
import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking';

const LoaderWrapper = styled.aside`
  position: absolute;
  left: 45%;
  top: 45%;
`;

const Dac7ProfileWithQuery = () => {
  const { desktop } = useViewport();
  const { isLoading, data } = useGetDac7Data();
  const trackDac7FormEvent = useTrackEvent();

  function redirectToForm() {
    trackDac7FormEvent('dac7_form_open', 'pageview', undefined, {
      touch_point_page: 'profile',
      seller_type: data?.type,
    });
    window.location.href = new URL(data?.details?.deepLink)?.pathname;
  }

  if (isLoading || !data || !data.deadline) {
    return <></>;
  }

  // TODO: will be done in the future
  // if (data?.blockedAt !== null) {
  //   return <DAC7ProfileBlockedAt />;
  // }

  if (data?.submittedAt) {
    return <DAC7ProfileSubmittedAt deepLink={new URL(data?.details?.deepLink)?.pathname} />;
  }

  return (
    <DAC7ProfileFillDetails
      deadline={data?.deadline}
      redirectToForm={redirectToForm}
      learnMore={data?.details?.learnMore}
      isBlockable={data?.isBlockable}
    />
  );
};

const Dac7Profile: React.FC = () => {
  useEffect(() => {
    const userId = getCookie(USER_ID_COOKIE);

    window.laquesisSetUserId?.(userId);
    return () => window.laquesisDropUserId?.();
  }, []);

  const exponentialBackoffDelayCalc = (attempt: number) =>
    Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 3,
        retryDelay: exponentialBackoffDelayCalc,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <Dac7ProfileWithQuery />
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default Dac7Profile;
